import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { PaymentButtonInterface } from 'common/types/entities/PaymentButtonInterface'
import { BorderStyleEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export const createPaymentButton = (
  parentId: string,
  masterBlockId?: MasterBlockIdType,
  loadingText?: string,
  text?: string,
  subText?: string,
): PaymentButtonInterface => {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.PaymentButton,
      parentId,
      masterBlockId,
    ),
    alignSelf: 'center',
    textFontSize: 20,
    border: {
      width: 1,
      style: BorderStyleEnum.none,
    },
    background: 'rgba(1, 116, 199, 1)',
    textColor: 'rgba(255, 255, 255, 1)',
    padding: {
      paddingTop: 9,
      paddingRight: 25,
      paddingBottom: 9,
      paddingLeft: 25,
    },
    mobilePadding: {
      paddingTop: 5,
      paddingRight: 5,
      paddingBottom: 5,
      paddingLeft: 5,
    },
    margin: {
      marginTop: 10,
      marginRight: 0,
      marginBottom: 10,
      marginLeft: 0,
    },
    mobileMargin: {
      marginTop: 5,
      marginBottom: 5,
      marginLeft: 0,
      marginRight: 0,
    },
    mobileTextFontSize: 20,
    mobileWidth: '100%',
    width: '100%',
    subTextFontSize: 14,
    loadingText,
    text: text ?? '',
    subText,
  }
}
